import {conversionBooleanoJson, conversionFechaJson, conversionStringJson, convertirFechaFirebase} from './utiles_objetos';


export class Configuracion {
    constructor({
        nombreEmpresa = "",

        //links de carpetas
        idcarpetaSolicitudes = "",
        idcarpetaPagos = "",
        idcarpetaEntregaTutores = "",
        idCalendarioReunion = "",

        //business whatsapp
        idWhatsappFacebook = "",
        idCuentaWhatsapp = "",
        tokenWhatsappFacebook = "",

        //plugins
        pluginSolicitudes = false,
        pluginCarpetaPagos = false,
        pluginEntregaTutores = false,
        pluginReunion = false,
        pluginWhatsapp = false,
        
        pagoExtraTemporaneo = false,
        manejoPagoSocios = false,
        aceptarNuevosTutores = false,
        manejoProPlataforma = false,
        manejoTesis = false,
        manejoWhatsapp = false,
        
        CONFIRMACION_CLIENTE = '',
        SOLICITUD = '',
        plantillaSolicitudTesis = '',
        plantillaSolicitudAsesoria = '',
        plantillaSolicitudExamen = '',
        plantillaSolicitudTaller = '',

        cuentaProfesional = [],

        //servicios por empresas
        servicios_empresas = {},

        //validarores locales
        configuracion_completa = false,
        elementosFaltantes = [],

    } = {}) {
        this.nombreEmpresa = nombreEmpresa;
        this.idCalendarioReunion = idCalendarioReunion;
        this.pluginSolicitudes = pluginSolicitudes;
        this.pluginCarpetaPagos = pluginCarpetaPagos;
        this.pluginEntregaTutores = pluginEntregaTutores;
        this.pluginReunion = pluginReunion;
        this.pagoExtraTemporaneo = pagoExtraTemporaneo;
        this.manejoPagoSocios = manejoPagoSocios;
        this.aceptarNuevosTutores = aceptarNuevosTutores;
        this.idcarpetaSolicitudes = idcarpetaSolicitudes;
        this.idcarpetaPagos = idcarpetaPagos;
        this.idcarpetaEntregaTutores = idcarpetaEntregaTutores;
        this.idWhatsappFacebook = idWhatsappFacebook;
        this.tokenWhatsappFacebook = tokenWhatsappFacebook;
        this.idCuentaWhatsapp = idCuentaWhatsapp;
        this.cuentaProfesional = cuentaProfesional;
        this.servicios_empresas = servicios_empresas;
        this.CONFIRMACION_CLIENTE = CONFIRMACION_CLIENTE;
        this.SOLICITUD = SOLICITUD;
        this.plantillaSolicitudTesis = plantillaSolicitudTesis;
        this.plantillaSolicitudAsesoria = plantillaSolicitudAsesoria;
        this.plantillaSolicitudExamen = plantillaSolicitudExamen;
        this.plantillaSolicitudTaller = plantillaSolicitudTaller;
        this.configuracion_completa = configuracion_completa;
        this.elementosFaltantes = elementosFaltantes;
    }

    static fromJson(json){
       
        //no obligatorioo
        const idCalendarioReunionLocal = json['idCalendarioReunion'] || '';
        const pluginReunionLocal = (idCalendarioReunionLocal == "" ? false : true);;

        //OBLIGATORIO
        //comprobador de configuracion
        const nombreEmpresaLocal = json['nombre_empresa'] || '';

        const idcarpetaSolicitudesLocal = json['idcarpetaSolicitudes'] || '';
        const idcarpetaPagosLocal = json['idcarpetaPagos'] || '';
        const idcarpetaEntregaTutoresLocal = json['idcarpetaEntregaTutores'] || '';

        const pluginSolicitudesLocal = (idcarpetaSolicitudesLocal == "" ? false : true);
        const pluginCarpetaPagosLocal = (idcarpetaPagosLocal == "" ? false : true);
        const pluginEntregaTutoresLocal = (idcarpetaEntregaTutoresLocal == "" ? false : true);

        const idWhatsappFacebookLocal = json['idWhatsappFacebook'] || '';
        const tokenWhatsappFacebookLocal = json['tokenWhatsappFacebook'] || '';
        const idCuentaWhatsappLocal = json['idCuentaWhatsapp'] || '';

        const servicios_empresasLocal = json['servicios_empresas'] || {};

        const CONFIRMACION_CLIENTELocal = json['CONFIRMACION_CLIENTE'] || {};
        const SOLICITUDLocal = json['SOLICITUD'] || {};
        const plantillaSolicitudTesisLocal = json['plantillaSolicitudTesis'] || {};
        const plantillaSolicitudAsesoriaLocal = json['plantillaSolicitudAsesoria'] || {};
        const plantillaSolicitudExamenLocal = json['plantillaSolicitudExamen'] || {};
        const plantillaSolicitudTallerLocal = json['plantillaSolicitudTaller'] || {};

        const elementosFaltantes = [];
        

        //PLANTILLAS DE TESIS,ASESORIAS, EXAMENE,S TALLERES
        // 2. Realizar validaciones individuales para cada campo obligatorio.
        // Validar cadenas de texto
        if (!nombreEmpresaLocal) elementosFaltantes.push('Falta el nombre de la empresa (nombre_empresa).');
        if (!idcarpetaSolicitudesLocal) elementosFaltantes.push('Falta el ID de la carpeta de solicitudes (idcarpetaSolicitudes).');
        if (!idcarpetaPagosLocal) elementosFaltantes.push('Falta el ID de la carpeta de pagos (idcarpetaPagos).');
        if (!idcarpetaEntregaTutoresLocal) elementosFaltantes.push('Falta el ID de la carpeta de entrega de tutores (idcarpetaEntregaTutores).');

        // Validar objetos (que no estén vacíos)
        if (Object.keys(servicios_empresasLocal).length === 0) elementosFaltantes.push('No se han configurado los servicios de la empresa (servicios_empresas).');
        if (Object.keys(CONFIRMACION_CLIENTELocal).length === 0) elementosFaltantes.push('Falta la plantilla de confirmación al cliente (CONFIRMACION_CLIENTE).');
        if (Object.keys(SOLICITUDLocal).length === 0) elementosFaltantes.push('Falta la plantilla de solicitud general (SOLICITUD).');

        
        // 3. Determinar si la configuración está completa basado en si la lista de errores está vacía.
        const configuracion_completaLocal = elementosFaltantes.length === 0;

        console.log("tenemos entrando ",json['cuentaProfesional'],Array.isArray(json['cuentaProfesional']) );

        const cuentaProfesionalLocal =  Array.isArray(json['cuentaProfesional']) 
                ? json['cuentaProfesional'].map(cuentaData => CuentaProfesional.fromJson(cuentaData))
                : [];
        
        return new Configuracion({
            nombreEmpresa: nombreEmpresaLocal,
            idCalendarioReunion:idCalendarioReunionLocal,

            pluginSolicitudes: pluginSolicitudesLocal,
            pluginCarpetaPagos: pluginCarpetaPagosLocal,
            pluginEntregaTutores: pluginEntregaTutoresLocal,
            pluginReunion: pluginReunionLocal,

            //booleano, configuraciones
            pagoExtraTemporaneo: json['pagoExtraTemporaneo'] || false,
            manejoPagoSocios: json['manejoPagoSocios'] || false,
            aceptarNuevosTutores : json['aceptarNuevosTutores'] || true,

            idcarpetaSolicitudes : idcarpetaSolicitudesLocal,
            idcarpetaPagos : idcarpetaPagosLocal,
            idcarpetaEntregaTutores : idcarpetaEntregaTutoresLocal,
            idWhatsappFacebook : idWhatsappFacebookLocal,
            tokenWhatsappFacebook : tokenWhatsappFacebookLocal,
            idCuentaWhatsapp : idCuentaWhatsappLocal,

            cuentaProfesional : cuentaProfesionalLocal,
            servicios_empresas: servicios_empresasLocal,

            CONFIRMACION_CLIENTE: CONFIRMACION_CLIENTELocal,
            SOLICITUD: SOLICITUDLocal,
            plantillaSolicitudTesis: plantillaSolicitudTesisLocal,
            plantillaSolicitudAsesoria: plantillaSolicitudAsesoriaLocal,
            plantillaSolicitudExamen: plantillaSolicitudExamenLocal,
            plantillaSolicitudTaller: plantillaSolicitudTallerLocal,
            configuracion_completa: configuracion_completaLocal,
            elementosFaltantes: elementosFaltantes,
        });

    }

    toJson(){

    }

    toMap(){

    }

    //update from json
    updateFromJson(updateData){

        if (!updateData || typeof updateData !== 'object') {
            console.warn('updateData debe ser un objeto válido');
            return;
        }

        Object.keys(updateData).forEach(field => {
            const value = updateData[field];
            console.log(`🔧 Procesando campo: ${field}, tipo: ${typeof value}`);
        
            switch(field) {
              // Números
              case 'nombre_empresa':
                this.nombreEmpresa = conversionStringJson(value, this.nombreEmpresa);
                break;

              case 'idCalendarioReunion':
                this.idCalendarioReunion = conversionStringJson(value, this.idCalendarioReunion);
                break;

              case 'pagoExtraTemporaneo':
                this.pagoExtraTemporaneo = conversionBooleanoJson(value, this.pagoExtraTemporaneo);
                break;

              case 'manejoPagoSocios':
                this.manejoPagoSocios = conversionBooleanoJson(value, this.manejoPagoSocios);
                break;

              case 'aceptarNuevosTutores':
                this.aceptarNuevosTutores = conversionBooleanoJson(value, this.aceptarNuevosTutores);
                break;

              case 'idcarpetaSolicitudes':
                this.idcarpetaSolicitudes = conversionStringJson(value, this.idcarpetaSolicitudes);
                break;

              case 'idcarpetaPagos':
                this.idcarpetaPagos = conversionStringJson(value, this.idcarpetaPagos);
                break;

              case 'idcarpetaEntregaTutores':
                this.idcarpetaEntregaTutores = conversionStringJson(value, this.idcarpetaEntregaTutores);
                break;

              case 'idWhatsappFacebook':
                this.idWhatsappFacebook = conversionStringJson(value, this.idWhatsappFacebook);
                break;

              case 'tokenWhatsappFacebook':
                this.tokenWhatsappFacebook = conversionStringJson(value, this.tokenWhatsappFacebook);
                break;

              case 'idCuentaWhatsapp':
                this.idCuentaWhatsapp = conversionStringJson(value, this.idCuentaWhatsapp);
                break;

              case 'CONFIRMACION_CLIENTE':
                this.CONFIRMACION_CLIENTE = conversionStringJson(value, this.CONFIRMACION_CLIENTE);
                break;

              case 'SOLICITUD':
                this.SOLICITUD = conversionStringJson(value, this.SOLICITUD);
                break;

              case 'plantillaSolicitudTesis':
                this.plantillaSolicitudTesis = conversionStringJson(value, this.plantillaSolicitudTesis);
                break;

              case 'plantillaSolicitudAsesoria':
                this.plantillaSolicitudAsesoria = conversionStringJson(value, this.plantillaSolicitudAsesoria);
                break;

              case 'plantillaSolicitudExamen':
                this.plantillaSolicitudExamen = conversionStringJson(value, this.plantillaSolicitudExamen);
                break;

              case 'plantillaSolicitudTaller':
                this.plantillaSolicitudTaller = conversionStringJson(value, this.plantillaSolicitudTaller);
                break;
        
              default:
                console.warn(`Campo desconocido en update data de Solicitudes: ${field}`);
                break;
            }
        });

    }
    getFieldValue(fieldPath) {
        console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
        
        if (fieldPath.includes('.')) {
            const [objectName, fieldName] = fieldPath.split('.');
            const value = this[objectName]?.[fieldName];
            console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
            return value;
        }
        
        const value = this[fieldPath];
        console.log(`📝 Valor directo ${fieldPath}:`, value);
        return value;
    }

}

export class CuentaProfesional{
    constructor({
        nombreCuenta = "",
        correo = "",
        linkCuenta = "",
        contrasena = "",
        fechaActualizacionCuenta = new Date(),
        reportarErrorCuenta = new Date(),
    } = {}) {
        this.nombreCuenta = nombreCuenta;
        this.correo = correo;
        this.linkCuenta = linkCuenta;
        this.contrasena = contrasena;
        this.fechaActualizacionCuenta = fechaActualizacionCuenta;
        this.reportarErrorCuenta = reportarErrorCuenta;
    }

    static fromJson(json){

      //console.log("ingresando cuenta, tenemos json",json);

        const fechaActualizacionLocal = convertirFechaFirebase(json['fechaActualizacionCuenta']);
        const fechaErrorLocal = convertirFechaFirebase(json['reportarErrorCuenta']);

        return new CuentaProfesional({
            nombreCuenta: json['nombreCuenta'] || '',
            correo : json['correo'] || '',
            linkCuenta : json['linkCuenta'] || '',
            contrasena : json['contrasena'] || '',
            fechaActualizacionCuenta : fechaActualizacionLocal,
            reportarErrorCuenta : fechaErrorLocal,
        });
        
    }

    updateFromJson(updateData){

        if (!updateData || typeof updateData !== 'object') {
            console.warn('updateData debe ser un objeto válido');
            return;
        }

        Object.keys(updateData).forEach(field => {
            const value = updateData[field];
            console.log(`🔧 Procesando campo: ${field}, tipo: ${typeof value}`);
        
            switch(field) {

              case 'correo':
                this.correo = conversionStringJson(value, this.correo);
                break;

              case 'nombreCuenta':
                this.nombreCuenta = conversionStringJson(value, this.nombreCuenta);
                break;

              case 'linkCuenta':
                this.linkCuenta = conversionStringJson(value, this.linkCuenta);
                break;

              case 'contrasena':
                this.contrasena = conversionStringJson(value, this.contrasena);
                break;

              case 'fechaActualizacionCuenta':
                this.fechaActualizacionCuenta = conversionFechaJson(value, this.fechaActualizacionCuenta);
                break;

              case 'reportarErrorCuenta':
                this.reportarErrorCuenta = conversionFechaJson(value, this.reportarErrorCuenta);
                break;

              default:
                console.warn(`Campo desconocido en update data de Solicitudes: ${field}`);
                break;
            }
        });

    }

    getFieldValue(fieldPath) {
        console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
        
        if (fieldPath.includes('.')) {
            const [objectName, fieldName] = fieldPath.split('.');
            const value = this[objectName]?.[fieldName];
            console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
            return value;
        }
        
        const value = this[fieldPath];
        console.log(`📝 Valor directo ${fieldPath}:`, value);
        return value;
    }

}
